import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from "@material-ui/core/styles";

const TooltipStyled = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#FFFFFF",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    padding: "3px",
  },
}))(Tooltip);

export default TooltipStyled


// WEBPACK FOOTER //
// ./src/components/common/TooltipStyled.js